/* eslint-disable */
// This file is generated by packages/glyph-decoder/scripts/generate-bold-atlas.ts.
// Evidence screenshots: 24
export const RAW_GLYPHS = [
    {
        char: " ",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "%",
        width: 9,
        anchorKey: "\b\"\b\u0000\u0000Ƞ\u0000",
        weightsB64: "AAAAAAAAAAAAJ/8nAABOAAAAxADEAACdAAAA/wD/AE4nAAAAxADEAJ0AAAAAJ/8nOzsn/ycAAAAAnQDEAMQAAAAnTgD/AP8AAACJAADEAMQAAAB2AAAn/ycAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "'",
        width: 3,
        anchorKey: "\u0006\u0006\u0000",
        weightsB64: "AAAA//8A//8AdnYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "(",
        width: 4,
        anchorKey: "`ϸ\u0000\u0000",
        weightsB64: "AAAAAAAAnQAAxE4AJ/8AAHb/AAD//wAA//8AAMT/AABi/wAAJ/8AAADETgAAAIkA",
    },
    {
        char: ")",
        width: 4,
        anchorKey: "\u0000ϸ`\u0000",
        weightsB64: "AAAAAJ0AAABOxAAAAP8nAAD/dgAA//8AAP//AAD/xAAA/2IAAP8nAE6dAACJAAAA",
    },
    {
        char: "-",
        width: 4,
        anchorKey: "\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP///wAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: ".",
        width: 3,
        anchorKey: "̀̀\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//8A//8AAAAAAAAA",
    },
    {
        char: "/",
        width: 3,
        anchorKey: "\u0000 \u0000",
        weightsB64: "AAAAAACdAABiAE4nAHYAAP8AAHYAJ04AYgAAnQAAAAAAAAAA",
    },
    {
        char: "0",
        width: 7,
        anchorKey: "pǼȂȂǼp\u0000",
        weightsB64: "AAAAAAAAAABO//9OAABO/ycn/04Anf8AAP+dAP//AAD//wD//wAA//8A//8AAP//AIn/AAD/nQBO/ycn/04AAE7//04AAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "1",
        width: 7,
        anchorKey: "\u0000\b\u0000ϼϾ\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAGL/AAAAAHb//wAAAP+J//8AAAB2AP//AAAAAAD//wAAAAAA//8AAAAAAP//AAAAAAD//wAAAAAA//8AAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "2",
        width: 7,
        anchorKey: "\u0000ȄȂɢȼȈ\u0000",
        weightsB64: "AAAAAAAAAACJ//9iAACd/wAA/3YAAAAAAP//AAAAACf/nQAAAAD//wAAAADE/ycAAADExAAAAABOxAAAAAAAxP//////AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "3",
        width: 7,
        anchorKey: "\u0000ĄȂ\u0012Ǭ@\u0000",
        weightsB64: "AAAAAAAAAABi//92AABi/wAA/8QAAAAAAP+JAAAAnf+dAAAAAAAn/2IAAAAAAP//AAAAAAD/xAB2/wAn/04AAHb/xE4AAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "4",
        width: 7,
        anchorKey: "ϼϾ\u0000",
        weightsB64: "AAAAAAAAAAAAAMT/AAAAADv//wAAAACd//8AAABOJ///AAAAiQD//wAAdgAA//8AAP///////wAAAAD//wAAAAAA//8AAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "5",
        width: 7,
        anchorKey: "\u0000ĞȂȒǢB\u0000",
        weightsB64: "AAAAAAAAAAD//////wAA/2IAAAAAO/8nAAAAAHb/xP92AAB2xAAn/2IAAAAAAP//AAAAAAD/xACJ/wAn/04AAHb//04AAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "6",
        width: 7,
        anchorKey: "pǬ\u0000ȒǤÀ\u0000",
        weightsB64: "AAAAAAAAAAAnnf+dAAAA/ycA/2IAdv8AAAAAAP+ddv92AAD//wAA/2IA//8AAP//AMT/AAD//wBO/ycA/04AAE7E/04AAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "7",
        width: 7,
        anchorKey: "\u0002Ȃς\u0012\u000e\u0002\u0000",
        weightsB64: "AAAAAAAAAP///////wAAAAAA/3YAAAAAnf8AAAAAO/87AAAAAMTEAAAAAAD/TgAAAABO/wAAAAAAnf8AAAAAAP//AAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "8",
        width: 7,
        anchorKey: "ǜȢȢǜ\u0000",
        weightsB64: "AAAAAAAAAABi//9iAAB2/wAA/3YA//8AAP//AGL/AAD/TgAAnf//xAAAdv8AAP92AP//AAD//wB2/wAA/3YAAGL//2IAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "9",
        width: 7,
        anchorKey: "\u0018ļɂ\u0002Ƽp\u0000",
        weightsB64: "AAAAAAAAAABO//9OAABO/wAn/04A//8AAP+dAP//AAD//wBi/wAA//8AAHb/dp3/AAAAAAD/dgBi/wAn/wAAAJ3/nScAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "A",
        width: 8,
        anchorKey: "ȀϠϠȀ\u0000",
        weightsB64: "AAAAAAAAAAAAAP///wAAAAAn////JwAAAE7/dv9OAAAAif8n/50AAAD/xADE/wAAAP92AGL/AABO//////9OAHb/AAAA/3YA//8AAAD//wAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "B",
        width: 8,
        anchorKey: "ϾϾȢȢȢǜ\u0000",
        weightsB64: "AAAAAAAAAAD//////4kAAP//AAAA/50A//8AAAD//wD//wAAAP9OAP//////iQAA//8AAAD/nQD//wAAAP//AP//AAAA/3YA//////92AAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "C",
        width: 8,
        anchorKey: "`Ǽ\u0000Ȃ\u0002Ą\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAIn//04AAAD/YgAA/3YAYv8AAAAAAADE/wAAAAAAAP//AAAAAAAA//8AAAAAAABi/wAAAAAAAAD/YgAA/3YAAACJ/8ROAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "D",
        width: 8,
        anchorKey: "ϾϾȂȂ\u0000Ǽp\u0000",
        weightsB64: "AAAAAAAAAAD/////nScAAP//AABi/wAA//8AAAD/YgD//wAAAP//AP//AAAA//8A//8AAAD//wD//wAAAP9iAP//AABi/wAA/////50AAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "E",
        width: 7,
        anchorKey: "ϾϾȢȢȢȢ\u0000",
        weightsB64: "AAAAAAAAAP///////wD//wAAAAAA//8AAAAAAP//AAAAAAD///////8A//8AAAAAAP//AAAAAAD//wAAAAAA////////AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "F",
        width: 6,
        anchorKey: "ϾϾ\"\"\"\u0000",
        weightsB64: "AAAAAAAA//////8A//8AAAAA//8AAAAA//8AAAAA//////8A//8AAAAA//8AAAAA//8AAAAA//8AAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "G",
        width: 8,
        anchorKey: " Ǽ\u0000ȂȢǤǠ\u0000",
        weightsB64: "AAAAAAAAAAAAAIn//2IAAAD/YgAA/4kAYv8AAAAAAADE/wAAAAAAAP//AAD///8AxP8AAAD//wBi/wAAAP//AAD/YgA7//8AAACJ//92JwAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "H",
        width: 8,
        anchorKey: "ϾϾ   ϾϾ\u0000",
        weightsB64: "AAAAAAAAAAD//wAAAP//AP//AAAA//8A//8AAAD//wD//wAAAP//AP////////8A//8AAAD//wD//wAAAP//AP//AAAA//8A//8AAAD//wAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "I",
        width: 3,
        anchorKey: "ϾϾ\u0000",
        weightsB64: "AAAA//8A//8A//8A//8A//8A//8A//8A//8A//8AAAAAAAAA",
    },
    {
        char: "J",
        width: 7,
        anchorKey: "ƀȀȀǾþ\u0000",
        weightsB64: "AAAAAAAAAAAAAAD//wAAAAAA//8AAAAAAP//AAAAAAD//wAAAAAA//8AAAAAAP//AP//AAD//wBi/wAA/2IAAHb//2IAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "K",
        width: 8,
        anchorKey: "ϾϾ \u00108ǀȀ\u0000",
        weightsB64: "AAAAAAAAAAD//wAAAMTEAP//AACJxAAA//8Adv8nAAD//07//wAAAP///2L/TgAA//8AAMT/AAD//wAATv8nAP//AAAA/50A//8AAAB2/wAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "L",
        width: 7,
        anchorKey: "ϾϾȀȀȀȀ\u0000",
        weightsB64: "AAAAAAAAAP//AAAAAAD//wAAAAAA//8AAAAAAP//AAAAAAD//wAAAAAA//8AAAAAAP//AAAAAAD//wAAAAAA////////AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "M",
        width: 10,
        anchorKey: "ϾϾ\u0006`΀`\u0006ϾϾ\u0000",
        weightsB64: "AAAAAAAAAAAAAP///wAAAP///wD///8nACf///8A//+dTgBinf//AP//Tp0AnU7//wD//yf/AP8n//8A//8A/2L/AP//AP//AMT/xAD//wD//wBi/2IA//8A//8AJ/8nAP//AAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "N",
        width: 8,
        anchorKey: "ϾϾ\b ϾϾ\u0000",
        weightsB64: "AAAAAAAAAAD//ycAAP//AP//nQAA//8A////JwD//wD//8SdAP//AP//O/8n//8A//8AxMT//wD//wAn////AP//AACd//8A//8AACf//wAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "O",
        width: 9,
        anchorKey: " ø\u0000ȂȂ\u0000ø \u0000",
        weightsB64: "AAAAAAAAAAAAAAB2//9iAAAAAMSJAACJxAAAYv8AAAAA/2IAxP8AAAAA/8QA//8AAAAA//8AxP8AAAAA/8QAYv8AAAAA/2IAAMSJAACJxAAAAABi//9iAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "P",
        width: 8,
        anchorKey: "ϾϾBBB<\u0018\u0000",
        weightsB64: "AAAAAAAAAAD//////2IAAP//AAAn/2IA//8AAAD//wD//wAAAP//AP//AAA7/04A//////9OAAD//wAAAAAAAP//AAAAAAAA//8AAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "Q",
        width: 9,
        anchorKey: " ø\u0000ȂȂĀǸ`\u0000",
        weightsB64: "AAAAAAAAAAAAAABi//9iAAAAAMSJAACJxAAAYv8AAAAA/04AxP8AAAAA/8QA//8AAAAA//8AxP8AAAAA//8AYv8AAGIA/4kAAMSdACf//ycAAABi//+JxAAAAAAAAAAAAGIAAAAAAAAAAAAA",
    },
    {
        char: "R",
        width: 8,
        anchorKey: "ϾϾ\"\"b̈\u0000",
        weightsB64: "AAAAAAAAAAD//////4kAAP//AAAA/50A//8AAAD//wD//wAAAP+JAP//////dgAA//8AAP+JAAD//wAAJ/9OAP//AAAAnf8A//8AAAAn/3YAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "S",
        width: 8,
        anchorKey: "\bĜȰȢbǄ\u0000",
        weightsB64: "AAAAAAAAAAAATsT//2IAAHb/AAAA/50A//8nAAAAAAB2//+JAAAAAACd////dgAAAAAnnf//dgAAAAAAJ///AJ3/AAAA/3YAAGL//8ROAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "T",
        width: 7,
        anchorKey: "\u0002\u0002ϾϾ\u0002\u0002\u0000",
        weightsB64: "AAAAAAAAAP///////wAAAP//AAAAAAD//wAAAAAA//8AAAAAAP//AAAAAAD//wAAAAAA//8AAAAAAP//AAAAAAD//wAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "U",
        width: 8,
        anchorKey: "~Ǿ\u0000Ȁ\u0000Ǿ~\u0000",
        weightsB64: "AAAAAAAAAAD//wAAAP//AP//AAAA//8A//8AAAD//wD//wAAAP//AP//AAAA//8A//8AAAD//wDE/wAAAP/EAE7/OwAn/04AAE7E/8ROAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "V",
        width: 8,
        anchorKey: "\u000epƀ̀ƀp\u000e\u0000",
        weightsB64: "AAAAAAAAAAD/AAAAAAD/if9OAAAATv8n/50AAACd/wB2/wAAAP+JACf/TgBO/ycAAP/EAMT/AAAAYv9O/2IAAAAn////JwAAAADE/8QAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "W",
        width: 12,
        anchorKey: "\u001eǠ΀Ǡ>\u000e>Ǡ΀Ϡ\u001e\u0000",
        weightsB64: "AAAAAAAAAAAAAAAA/wAAAP///wAAAP+d/ycAAP///wAAJ/9O/04AO////zsATv8n/50Aif9O/3YAif8AxP8A//8A//8A/8QAYv9O/2IAdv9O/2IAJ////ycAJ////zsAAP///wAAAP///wAAAMT/nQAAAJ3//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "X",
        width: 8,
        anchorKey: "ȂƌøpøƌȂ\u0000",
        weightsB64: "AAAAAAAAAAD/iQAAAIn/AGL/OwA7/2IAAP//AP//AAAATv///04AAAAA////AAAAAE7///9OAAAA//8A//8AAGL/OwA7/2IA/4kAAACJ/wAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "Y",
        width: 7,
        anchorKey: "\u0004\u0018ϠϠ\u0018\u0004\u0002",
        weightsB64: "AAAAAAAAAIkAAAAAif//OwAAO/87if8AAP+JAAD/iYn/AAAAO///OwAAAAD//wAAAAAA//8AAAAAAP//AAAAAAD//wAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "Z",
        width: 7,
        anchorKey: "̂ʂȢȒȆȂ\u0000",
        weightsB64: "AAAAAAAAAP///////wAAAAAA/2IAAAAAncQAAAAAYv8AAAAAAP9iAAAAAMSdAAAAAGL/AAAAAAD/TgAAAAAA////////AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "[",
        width: 4,
        anchorKey: "࿾࿾ࠂ\u0000",
        weightsB64: "AAAAAP///wD//wAA//8AAP//AAD//wAA//8AAP//AAD//wAA//8AAP//AAD///8A",
    },
    {
        char: "]",
        width: 4,
        anchorKey: "ࠂ࿾࿾\u0000",
        weightsB64: "AAAAAP///wAA//8AAP//AAD//wAA//8AAP//AAD//wAA//8AAP//AAD//wD///8A",
    },
    {
        char: "a",
        width: 7,
        anchorKey: "ǀ\b\bϰϠ\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAHb//50AAIkAAAD/xAAAAE6J//8AJ/9iAP//AP//AAD//wDE/wAn//8AJ8TETv//AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "b",
        width: 7,
        anchorKey: "ϾϾ\u0000\u0000ǰ@\u0000",
        weightsB64: "AAAAAAAAAP//AAAAAAD//wAAAAAA//87xHYAAP//Tif/TgD//wAA/8QA//8AAP//AP//AAD/xAD//04n/04A//8nxIkAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "c",
        width: 7,
        anchorKey: "@ǰȀȈĐ\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAE7E/3YAAE7/JwD/dgDE/wAAAAAA//8AAAAAAMT/AAAAAABO/ycA/4kAAE7//3YAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "d",
        width: 7,
        anchorKey: "@ǰ\u0000\u0000ϾϾ\u0000",
        weightsB64: "AAAAAAAAAAAAAAD//wAAAAAA//8AAHadJ///AE7/J07//wDE/wAA//8A//8AAP//AMT/AAD//wBO/yc7//8AAHbEJ///AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "e",
        width: 7,
        anchorKey: "@ǰHɈŰ@\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAE7//04AADv/Jyf/OwDE/wAA/50A////////AMT/AAAAAABO/ycA/3YAAE7E/3YAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "f",
        width: 4,
        anchorKey: "ϼϼ\n\u0000",
        weightsB64: "AAAAACed/3b//wAA////AP//AAD//wAA//8AAP//AAD//wAA//8AAAAAAAAAAAAA",
    },
    {
        char: "g",
        width: 7,
        anchorKey: "@ǰࠀࠀ߸ϸ\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAHadJ///AE7/J07//wDE/wAA//8A//8AAP//AMT/AAD//wBO/ydO//8AAHadJ///AMQnAAD/dgAAnf//dgAA",
    },
    {
        char: "h",
        width: 7,
        anchorKey: "ϾϾ\u0000\u0000ϰϠ\u0000",
        weightsB64: "AAAAAAAAAP//AAAAAAD//wAAAAAA//8AdsQnAP//TgD/nQD//wAA//8A//8AAP//AP//AAD//wD//wAA//8A//8AAP//AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "i",
        width: 3,
        anchorKey: "ϺϺ\u0000",
        weightsB64: "AAAA//8AAAAA//8A//8A//8A//8A//8A//8A//8AAAAAAAAA",
    },
    {
        char: "j",
        width: 3,
        anchorKey: "࿺Ϻ\u0000",
        weightsB64: "AAAA//8AAAAA//8A//8A//8A//8A//8A//8A//8A/50A/wAA",
    },
    {
        char: "k",
        width: 7,
        anchorKey: "ϾϾ\u0000 ƀȀ\u0000",
        weightsB64: "AAAAAAAAAP//AAAAAAD//wAAAAAA//8AAMTEAP//AMTEAAD//8T/JwAA///ExHYAAP//ADv/AAD//wAA/3YA//8AAGL/AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "l",
        width: 3,
        anchorKey: "ϾϾ\u0000",
        weightsB64: "AAAA//8A//8A//8A//8A//8A//8A//8A//8A//8AAAAAAAAA",
    },
    {
        char: "m",
        width: 11,
        anchorKey: "ϸϸ\u0000\u0000ϰϰ\u0000\u0000ϰϠ\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//8nicQ7J8TEJwD//zsA//9OAP+dAP//AAD//wAA//8A//8AAP//AAD//wD//wAA//8AAP//AP//AAD//wAA//8A//8AAP//AAD//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "n",
        width: 7,
        anchorKey: "ϸϸ\u0000\u0000ϰϠ\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAA//8nicQnAP//OwD/xAD//wAA//8A//8AAP//AP//AAD//wD//wAA//8A//8AAP//AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "o",
        width: 7,
        anchorKey: "@ǰ\u0000\bǰ@\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAE7E/04AADv/Jyf/OwCd/wAA/50A//8AAP//AJ3/AAD/nQA7/ycn/zsAAE7ExE4AAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "p",
        width: 7,
        anchorKey: "࿸࿸\u0000Ȁǰ@\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAA//8nxIkAAP//Tif/TgD//wAA/8QA//8AAP//AP//AAD/xAD//04n/04A//8n/3YAAP//AAAAAAD//wAAAAAA",
    },
    {
        char: "q",
        width: 7,
        anchorKey: "@ǰ\b\u0000࿸࿸\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAHb/J///AE7/J07//wDE/wAA//8A//8AAP//AMT/AAD//wBO/ydi//8AAHbEAP//AAAAAAD//wAAAAAA//8A",
    },
    {
        char: "r",
        width: 5,
        anchorKey: "ϸϸ\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAA//92iQD//wAAAP//AAAA//8AAAD//wAAAP//AAAA//8AAAAAAAAAAAAAAAAA",
    },
    {
        char: "s",
        width: 7,
        anchorKey: "\u0000İɈɈƐ\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAIn//3YAAJ3/AAD/iQDE/4knAAAAJ8T//8QnAAAAAE7/xACJ/wAA/50AAGL//4kAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "t",
        width: 4,
        anchorKey: "Ǽϼ\b\u0000",
        weightsB64: "AAAAAAB2AAD//wAA////AP//AAD//wAA//8AAP//AAD//wAAJ/+JAAAAAAAAAAAA",
    },
    {
        char: "u",
        width: 7,
        anchorKey: "øǸ\u0000\u0000ϸϸ\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAA//8AAP//AP//AAD//wD//wAA//8A//8AAP//AP//AAD//wCd/wA7//8AJ8SdAP//AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "v",
        width: 6,
        anchorKey: "0ƀ̀ƀ0\b",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAdgAAAHb//wAAAP+d/04ATv8nxMQAxMQAO/92/zsAAP///wAAAE7/TgAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "w",
        width: 10,
        anchorKey: "\bϠ΀à8À΀Ϡ\b\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/04AO/8nAE7/AHaJAHb/YgCJdgB2/wD//8QA/3YAO/9O/zv/Tv87ACf///8A////JwAA//92AGL//wAAAP//OwAn//8AAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "x",
        width: 7,
        anchorKey: "ȈĐ@@ĐȈ\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAA/4kAAIn/ADv/Jzv/OwAAncTEnQAAACf//04AAADEncTEAABO/ycn/04A/4kAAIn/AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "y",
        width: 6,
        anchorKey: "࠸π܀ǀ8\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAA/wAAAP+d/ycAJ/9O/3YAdv8AxP8A/50AYv92/04AJ////wAAAP//nQAAAJ3/AAAA/50nAAAA",
    },
    {
        char: "z",
        width: 6,
        anchorKey: "ȈΈɈȘȈ\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAA//////8AAAAA/2IAAACdxAAAADv/JwAAAP+JAAAAdv8AAAAA//////8AAAAAAAAAAAAAAAAA",
    },
];
//# sourceMappingURL=glyph_atlas_cleartype_bgr_bold.js.map